export interface FetchWithTimeoutOptions extends RequestInit {
  signal?: AbortController['signal'] | null
  timeoutMs?: number
}

// Based on https://stackoverflow.com/a/57888548/915875
const fetchWithTimeout = (
  url: RequestInfo,
  didTimeoutFlag: { didTimeout: boolean },
  { signal, timeoutMs = 50_000, ...options }: FetchWithTimeoutOptions = {},
): Promise<Response | Error> | Error => {
  const controller = new AbortController()
  const context = {
    url,
    signal,
    timeoutMs,
    options,
    controller,
  } as const

  console.info(`[${options.method ?? 'GET'}] '${url.toString()}'...`, { payload: options.body, ...context })

  try {
    const requestPromise = fetch(url, { signal: controller.signal, ...options })

    signal?.addEventListener('abort', () => controller.abort(), { once: true })

    const timeoutId = setTimeout(function abortFetchOnTimeoutHit() {
      console.warn(`Aborting request to '${url.toString()}' due to timeout hit of ${timeoutMs}ms.`, {
        requestPromise,
        ...context,
      })

      controller.abort()

      didTimeoutFlag.didTimeout = true
    }, timeoutMs)

    return requestPromise.finally(() => clearTimeout(timeoutId))
  } catch (ex) {
    return ex as Error
  }
}

export default fetchWithTimeout;